import { VariavelSelect } from "../variavel/variavel-select.model";

export class EtapaVariavelEnvio{
  id?: number;
  etapaId?: number;
  variavel?: VariavelSelect;
}
